
   <div class="page-title-area">
    <img src="assets/images/apple_ent.png" alt="Page Background" class="page-bg">
    <button class="back-arrow-btn" (click)="navigateToHome()">
        <i class="fas fa-chevron-left fa-2x"></i>
    </button>
    <div class="container">
        <div class="page-title-content">
            <h2>Drive Innovation with Apple</h2>
        </div>
    </div>

</div>

<section class="animated-cards-section ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="innovation-image">
                    <div class="circular-image-container">
                        <img src="assets/images/drive_innovate.png" alt="Apple Innovation" class="circular-image">
                       <!--  <div class="icon-overlay">
                            <i class="fas fa-microchip"></i>
                            <i class="fas fa-shield-alt"></i>
                            <i class="fas fa-cogs"></i>
                            <i class="fas fa-brain"></i>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="innovation-content">
                    <h2>Drive Innovation with Apple Technology</h2>
                    <div class="feature-list">
                        <div class="feature-item">
                            <i class="fas fa-microchip"></i>
                            <p>Powered by Apple Silicon and Neural Engine for unmatched performance</p>
                        </div>
                        <div class="feature-item">
                            <i class="fas fa-shield-alt"></i>
                            <p>Built-in security features like FileVault for complete data protection</p>
                        </div>
                        <div class="feature-item">
                            <i class="fas fa-cogs"></i>
                            <p>Seamless MDM framework for scalable device management</p>
                        </div>
                        <div class="feature-item">
                            <i class="fas fa-brain"></i>
                            <p>Apple Intelligence for smarter workflows and team collaboration</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="container mb-4">
    <div class="d-flex justify-content-end">
        <button class="btn back-btn" (click)="navigateToHome()">
            <i class="fas fa-arrow-left me-2"></i> Back to Home
        </button>
    </div>
</div>
<br>